import useTypedTranslation from '@hooks/useTypedTranslation'

interface PaginationInfoProps {
  currentCount: number
  totalCount: number
  className?: string
}

function PaginationInfo({
  currentCount,
  totalCount,
  className = 'text-sm text-gray-600 ml-1 mb-2 font-medium',
}: PaginationInfoProps) {
  const { t } = useTypedTranslation()

  if (currentCount === 0) return null

  return (
    <div className={className} data-testid='pagination-info'>
      {t('common.paginationInfo', { currentCount, totalCount })}
    </div>
  )
}

export default PaginationInfo